import $ from 'jquery';
import DfApi from '@/js/modules/df_api';
import confirmDialog from '@/js/modules/confirm_dialog';
import { initTooltips } from '@/js/modules/tooltips';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  const api = new DfApi();

  const replaceProjectAssigneesNode = (projectId, htmlNode) => {
    const assigneesSelector = `.project-assignees--container[data-project-id='${projectId}']`;
    const $assigneesNode = $(assigneesSelector);

    $assigneesNode.html(htmlNode);
    initTooltips($assigneesNode.find('.tooltip'));
  };

  const shouldProceedWithRemoval = ($target) => {
    const $assigneesContainer = $target.closest('.project-assignee');
    const $assignees = $assigneesContainer.find('.project-assignee__details');
    const removeMessage =
      'Removing the last assignee will result in assigning' +
      ' this project to the team admin. Do you want to proceed?';

    return $assignees.length > 1 || confirmDialog(removeMessage);
  };

  const toggleDesignerSelector = (event) => {
    stopClickPropagation(event);
    const projectId = $(event.currentTarget).data('project-id');

    $(`.designer-selector[data-project-id='${projectId}']`).toggleClass('hide');
  };

  const assignDesignerToProject = async (event) => {
    stopClickPropagation(event);

    const $target = $(event.currentTarget);
    const designerId = $target.data('designer-id');
    const projectId = $target.closest('.designer-selector').data('project-id');
    const response = await api.assignDesignerToProject(designerId, projectId);

    replaceProjectAssigneesNode(projectId, response.html_node);
  };

  const removeDesignerFromProject = async (event) => {
    stopClickPropagation(event);

    const $target = $(event.currentTarget);
    const projectId = $target.data('project-id');
    const projectDesignerId = $target.data('project-designer-id');

    if (await shouldProceedWithRemoval($target)) {
      const response = await api.removeDesignerAssignmentFromProject(projectDesignerId, projectId);
      replaceProjectAssigneesNode(projectId, response.html_node);
    }
  };

  const stopClickPropagation = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const closeAllDesignersSelectors = (event) => $('.designer-selector').addClass('hide');

  $(document).on('click', '.project-designer__selector', toggleDesignerSelector);
  $(document).on('click', '.designer-selector__option', assignDesignerToProject);
  $(document).on('click', '.project-assignee__remove', removeDesignerFromProject);
  $(document).on('click', '.project-assignee__destroy', removeDesignerFromProject);
  $(document).on('click', '.project-assignee [data-tippy-root]', stopClickPropagation);
  $(document).on('click', '.project-assignee .tooltip', stopClickPropagation);
  $(document).on('click', '#designer-projects', closeAllDesignersSelectors);
});
